export const ADD_PRODUIT = 'add_produit';
export const REMOVE_PRODUIT = 'remove_produit';
export const CLEAR = 'clear';
export const CHANGE_FORMAT_SPOT = 'change_format_spot';

export function addProduit(produitPanier) {
  return {type: ADD_PRODUIT, produitPanier};
}

export function removeProduit(produitPanier) {
  return {type: REMOVE_PRODUIT, produitPanier};
}

export function clear() {
  return {type: CLEAR};
}

export function changeFormatSpot(formatSpot) {
  return {type: CHANGE_FORMAT_SPOT, formatSpot};
}
